import { Modal, ModalContent, ModalBody, useDisclosure, ModalHeader, ModalFooter } from "@nextui-org/react";
import React, { useEffect, useState } from "react";
import Titel from "../Titel";
import useAxios from '../../../hooks/useAxios';
import axios from "axios";
import Tags from "../Paint/Tags";
import UploadGroupImages from "./UploadImagegroup";

const Form = ({ index, setReload, id }) => {
    const { AxiosPrivate } = useAxios()
    const { isOpen, onOpen, onOpenChange } = useDisclosure();
    const [data, setData] = useState({ images: [] })
    const [state, setState] = useState({})
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        const get = async () => {
            await axios.get(`/capillary-search/show/${id}`)
                .then(res => {
                    setState(res.data.data)
                    const { images, ...clearData } = res.data.data
                    setData({ images: [], ...clearData })
                })
                .catch(err => alert(err.response?.data.message))
        }

        if (isOpen)
            get()
    }, [isOpen])

    const handleSubmit = async (e) => {
        e.preventDefault()
        await AxiosPrivate.post(`/capillary-search/update/${data.id}`, { ...data, _method: "PUT" }, {
            headers: { 'Content-Type': 'multipart/form-data' },
            onUploadProgress: () => {
                setLoading(true)
            },
        })
            .then(res => {
                onOpenChange(false)
                setLoading(false)
                setReload(Math.random())
            })
            .catch(err => { alert(err.response?.data.message || 'مشکلی پیش آمده'); setLoading(false) })
    }

    return (
        <>
            <div onClick={onOpen} className='hover:bg-gray-300 cursor-pointer duration-250 rounded-full p-1'>گزینه ی {index + 1}</div>


            <Modal isOpen={isOpen} size="2xl" scrollBehavior={'inside'} onOpenChange={onOpenChange}>
                <ModalContent>
                    {(onClose) => (
                        <>
                            <ModalHeader dir="rtl" className="pr-12"><Titel title={'ویرایش'} className='sm:text-xl w-full' /></ModalHeader>
                            <ModalBody>
                                <form className="flex flex-col items-center" dir="rtl" onSubmit={handleSubmit}>
                                    <div className="w-full flex sm:items-center items-start gap-4 mb-4 sm:text-base text-sm sm:flex-row flex-col">
                                        <p>ایجاد: {new Date(data.created_at).toLocaleString('fa-IR')}</p><span className="sm:block hidden">|</span>
                                        <p>ویرایش: {new Date(data.updated_at).toLocaleString('fa-IR')}</p>
                                    </div>
                                    <div className="relative pb-6 mb-4 min-w-28 max-w-[100%] w-full">
                                        <UploadGroupImages setProduct={setData} label='افزودن عکس' name='images' images={state.images} />
                                    </div>
                                    <div className="relative pb-6 mb-4 min-w-28 max-w-[100%] w-full">
                                        <Tags data={data} id={2} setData={setData} errors={{}} touch={{}} name='tags' label='تگ ها' />
                                    </div>
                                    <button disabled={loading} className="text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br 
                                        focus:outline-none shadow-lg shadow-blue-500/50 dark:shadow-lg dark:shadow-blue-800/80 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 ">{loading ?
                                            <div role="status">
                                                <svg stroke="currentColor" aria-hidden="true" className="inline w-8 h-8 text-gray-200 animate-spin fill-gray-50" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M512 1024c-69.1 0-136.2-13.5-199.3-40.2C251.7 958 197 921 150 874c-47-47-84-101.7-109.8-162.7C13.5 648.2 0 581.1 0 512c0-19.9 16.1-36 36-36s36 16.1 36 36c0 59.4 11.6 117 34.6 171.3 22.2 52.4 53.9 99.5 94.3 139.9 40.4 40.4 87.5 72.2 139.9 94.3C395 940.4 452.6 952 512 952c59.4 0 117-11.6 171.3-34.6 52.4-22.2 99.5-53.9 139.9-94.3 40.4-40.4 72.2-87.5 94.3-139.9C940.4 629 952 571.4 952 512c0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 0 0-94.3-139.9 437.71 437.71 0 0 0-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.2C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3s-13.5 136.2-40.2 199.3C958 772.3 921 827 874 874c-47 47-101.8 83.9-162.7 109.7-63.1 26.8-130.2 40.3-199.3 40.3z"></path></svg>
                                                <span className="sr-only">Loading...</span>
                                            </div>
                                            : 'ثبت'}</button>
                                </form>
                            </ModalBody>
                            <ModalFooter />
                        </>
                    )}
                </ModalContent>
            </Modal>
        </>
    );
};

export default Form;